
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { SectorRankingComponent } from './sector-ranking.component';
import { RoleGuard } from '../../../_guards/role.guard';


const routes: Routes = [
    {
        path     : 'sector-ranking',
        component: SectorRankingComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        SectorRankingComponent
    ],
    entryComponents: [],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class SectorRankingModule
{
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/sector-ranking/sector-ranking.module.ts